// Single source of truth for email-address validation across REFSIX/Scorza
// (refauth newsletter + magic-link endpoints, phone forgot-password, etc.) so the
// validation cannot drift between call sites.

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns true for a well-formed `local@domain.tld` address: a single `@`, no
 * whitespace, and a TLD after a dot. Surrounding whitespace is ignored.
 */
export function isValidEmail(email: string): boolean {
    return typeof email === "string" && EMAIL_REGEX.test(email.trim());
}
